import React, { ComponentProps, ForwardedRef, forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../layout/Box';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Img } from './Img';
import { MediaCover } from './MediaCover';
import defaultAvatar from './resources/defaultAvatar.svg';
import type { BreakpointProp } from '../../utils/styles/breakpoints';

export const AvatarCover = styled(MediaCover).withConfig({ displayName: 'AvatarCover' })`
    border-radius: 50%;
    overflow: hidden;
    user-select: none;
    background-color: var(--background-primary);

    &::before {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        content: '';
        border-radius: 50%;
        box-shadow: inset 0 0 0 1px var(--divider);
    }
`;

interface AvatarProps extends ComponentProps<typeof Box> {
    title?: string;
    src?: string;
    size?: BreakpointProp<number>;
}

export const Avatar = forwardRef((props: AvatarProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { title = '', size = 32, src = defaultAvatar, ...other } = props;

    return (
        <AvatarCover ref={ref} width={size} ratio={1} dataTestId={DataTestId.AVATAR} {...other}>
            <Img src={src} alt={title} key={src} />
        </AvatarCover>
    );
});
